import axios from 'axios';

const api = axios.create({
    timeout: 10000
});

const URL = {
    UBT: {
        CONFIG: '/wfbs-svc/ubt/en/service/config',
    }
};

export default {
    ubt: {
        config: () => api.get(URL.UBT.CONFIG),
    }
};
